import keyMirror from 'keymirror';

export const solutionSetStatus = keyMirror({
  CMP: null,
  FAL: null,
  NRE: null,
  PAS: null,
});

export const solutionSetStatusLabel = {
  [solutionSetStatus.CMP]: 'Completed',
  [solutionSetStatus.FAL]: 'Failed',
  [solutionSetStatus.NRE]: 'Needs review',
  [solutionSetStatus.PAS]: 'Passed',
};
